import { FEATURE_FLAGS } from '../core/user/user';
import { LocalStorage } from 'Core/storage';
export function isAvpFlagOn() {
  let avpFeatureFlagEnabled = false;
  const featureFlags = LocalStorage.get(FEATURE_FLAGS);
  if (featureFlags) {
    avpFeatureFlagEnabled = featureFlags['avp_permissions'];
  }
  return avpFeatureFlagEnabled;
}
